import { create } from "zustand";
import type { Direction } from "@bus/shared";

interface AppState {
  routeId: string;
  direction: Direction;
  selectedVehicleId: string | null;
  selectedStopId: string | null;
  map3d: boolean;
  setRouteId: (routeId: string) => void;
  setDirection: (direction: Direction) => void;
  setRouteContext: (routeId: string, direction: Direction, selectedStopId?: string | null) => void;
  setSelectedVehicleId: (id: string | null) => void;
  setSelectedStopId: (id: string | null) => void;
  toggleMap3d: () => void;
  setMap3d: (enabled: boolean) => void;
}

export const useAppStore = create<AppState>((set) => ({
  routeId: new URLSearchParams(location.search).get("route") ?? "277",
  direction: 0,
  selectedVehicleId: null,
  selectedStopId: new URLSearchParams(location.search).get("stop"),
  // iOS WebKit can keep the base map alive while rejecting an optional
  // fill-extrusion layer. Start in the reliable 2D path; 3D remains opt-in.
  map3d: !(/iP(?:hone|ad|od)/.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)) && !matchMedia("(prefers-reduced-motion: reduce)").matches,
  setRouteId: (routeId) => set((state) => state.routeId === routeId ? state : { routeId, selectedVehicleId: null, selectedStopId: null }),
  setDirection: (direction) => set((state) => state.direction === direction ? state : { direction, selectedVehicleId: null, selectedStopId: null }),
  setRouteContext: (routeId, direction, selectedStopId = null) => set({ routeId, direction, selectedStopId, selectedVehicleId: null }),
  setSelectedVehicleId: (selectedVehicleId) => set({ selectedVehicleId }),
  setSelectedStopId: (selectedStopId) => set({ selectedStopId }),
  toggleMap3d: () => set((state) => ({ map3d: !state.map3d })),
  setMap3d: (map3d) => set({ map3d })
}));
